import type { DeepPartial } from '@luna/utils-ts';

import type { ProductSettings } from '../../types/ProductSettings';

export const productSettingsHRFeatureConfig: DeepPartial<ProductSettings> = {
    showTransactionConfirmation: true,
    showPortfolioNumber: false,
};
